<script>
import axios from 'axios'
export default {
  name: 'ExecutionProcessVariables',
  props: {
    execution: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      processVariables: [],
      loader: false,
      search: '',
      headers: [
        {
          text: 'Variable Name',
          value: 'name'
        },
        {
          text: 'Value',
          value: 'value'
        },
        {
          text: 'Type',
          value: 'type'
        }
      ]
    }
  },
  mounted() {
    this.getProcessVariables()
  },
  methods: {
    getProcessVariables() {
      this.loader = true
      axios
        .get(
          `/api/core/process-instance-variables-by-execution/${this.execution.hexId}`
        )
        .then(response => {
          let variables = response.data
          this.processVariables = Object.keys(variables).map(key => {
            return {
              name: key,
              value: variables[key]['value'],
              type: variables[key]['type']
            }
          })
          this.processVariables = this.processVariables.filter(variable => {
            return (
              variable.name !== 'ParentStackId' && variable.name !== 'RunStatus'
            )
          })
          this.loader = false
        })
        .catch(error => {
          console.log(error)
          this.processVariables = []
          this.loader = false
        })
    }
  }
}
</script>

<template>
  <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
    <v-card-title>
      <span class="body-1 beez-bold pl-3">Process Variables</span>
      <v-spacer />
      <v-list-tile-avatar>
        <v-icon>search</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-sub-title>
          <v-text-field v-model="search" color="secondary" label="Search" xs5>
          </v-text-field>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="search = ''">
          <v-icon>clear</v-icon>
        </v-btn>
        <span>Clear search</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="getProcessVariables">
          <v-icon>cached</v-icon>
        </v-btn>
        <span>Refresh</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="processVariables"
        :loading="loader"
        :search="search"
      >
        <template v-slot:items="props">
          <td class="text-xs-left">
            <div class="body-2 font-weight-bold orange--text">
              {{ props.item.name }}
            </div>
          </td>
          <td class="text-xs-left">
            <div class="body-1 font-weight-bold">
              {{ props.item.value }}
            </div>
          </td>
          <td class="text-xs-left">{{ props.item.type }}</td>
        </template>
        <template slot="no-data">
          <v-alert :value="true" color="info" icon="info">
            No process variables found
          </v-alert>
        </template>
        <template slot="no-results">
          <v-alert :value="true" color="warning" icon="warning">
            Your search for "{{ search }}" not found.
          </v-alert>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
